<!--
 * @Descripttion: 
 * @version: 1.0
 * @Author: Erik Zhang
 * @Date: 2021-02-14 23:36:16
 * @LastEditors: Erik Zhang
 * @LastEditTime: 2021-04-22 23:21:59
-->
<template>
  <div >
	  <div style="padding:20px;padding-bottom:0;">
		  <a-radio-group v-model="currentTab" style="margin-bottom: 16px">
		        <a-radio-button value="1">
		  			 结业换证管理
		        </a-radio-button>
		        <a-radio-button value="2">
		  			 重修管理
		        </a-radio-button>
		        <a-radio-button value="3">
		  			 成绩管理
		        </a-radio-button>
		      </a-radio-group>
	  </div>
   
	   <div v-if="currentTab=='1'" >
		   <GraduationManagement />
	   </div>
	   <div v-if="currentTab=='2'">
	   		   <RetakeManagement />
	   </div>
	   <div v-if="currentTab=='3'">
	   		   <ScoreManagement />
	   </div>
  </div>
</template>

<script>
import GraduationManagement from './modules/GraduationManagement.vue'
import RetakeManagement from './modules/RetakeManagement.vue'
import ScoreManagement from './modules/ScoreManagement.vue'
export default {
  components: {
      GraduationManagement,
      RetakeManagement,
      ScoreManagement
    },
  data() {
    return {
		 currentTab: '1'
	};
  },
  mounted() {},
  methods: {
	
  }
};
</script>
<style lang="less" scoped></style>
